<template>
  <div class="l-section menu-carousel" :class="{_loading: pending && !banner}">
    <div class="l-section-h menu-carousel__inner">
      <BasePreloader v-if="pending"/>
<!--      <h4 class="menu-carousel__title">{{banner.name}}</h4>-->
      <h4 class="menu-carousel__title">{{$t('Перегляньте меню ресторанів')}}</h4>
      <div class="menu-carousel__carousel">
        <div class="menu-carousel__wrap">
          <div ref="carousel"
               class="menu-carousel__container"
          >
            <div class="menu-carousel__list">
              <template v-if="banner">
                <div v-for="item in banner.images"
                     :key="item.id"
                     class="menu-carousel__slide"
                >
                  <a :href="item.link"
                     :title="item.title"
                     target="_blank"
                     class="menu-carousel__slide-inner"
                  >
                    <picture class="menu-carousel__slide-bg-wrap">
                      <source :srcset="item.image_preview"
                              media="(max-width: 767px)"
                      >
                      <img :src="item.image"
                           :alt="item.title"
                           class="menu-carousel__slide-bg"
                      >
                    </picture>
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>
        <button ref="slide-prev"
                type="button"
                class="menu-carousel__nav _prev"
        >
          <i class="fa fa-angle-left"></i>
        </button>
        <button ref="slide-next"
                type="button"
                class="menu-carousel__nav _next"
        >
          <i class="fa fa-angle-right"></i>
        </button>
      </div>
      <div class="menu-carousel__btn-wrap">
        <router-link :to="{name: 'delivery', params: {restaurantId: activeRestaurantId}}" class="base-btn">{{$t("Доставка")}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import {mapState} from 'vuex'

  export default {
    name: 'MenuCarousel',
    data() {
      return {
        swiper: null
      }
    },
    computed: {
      ...mapState('restaurants', ['active_restaurant']),
      activeRestaurantId() {
        let id = window.localStorage.getItem('active_restaurant_id') || null
        if (this.active_restaurant) {
          id = this.active_restaurant.id
        }
        return id
      },
      ...mapState('settings', ['settings']),
      ...mapState('settings', ['pending']),
      banner() {
        return this.settings && this.settings.pages && this.settings.pages.main.banner || {}
      }
    },
    methods: {
      createSwiper() {
        this.swiper = new Swiper(this.$refs['carousel'], {
          wrapperClass: 'menu-carousel__list',
          slideClass: 'menu-carousel__slide',
          slidesPerView: 'auto',
          watchOverflow: true,
          roundLengths: true,
          observer: true,
          speed: 600,
          navigation: {
            prevEl: this.$refs['slide-prev'],
            nextEl: this.$refs['slide-next'],
            disabledClass: '_disabled',
            hiddenClass: '_hidden',
            lockClass: '_hidden'
          }
        })
      }
    },
    mounted() {
      this.createSwiper()
    },
    beforeDestroy() {
      this.swiper.destroy()
    }
  }
</script>

<style>

</style>
